export default __webpack_public_path__ + "static/media/Background_00177.efd4ee5f.png";